<script lang="ts">
	import FileUploader from '$lib/components/FileUploader/FileUploader.svelte';
	import { onMount, tick } from 'svelte';
	import type { Editor } from 'svelte-tiptap';
	import { composerInitBlock } from '$lib/components/TextEditor/PostComposer/composerStore';
	import type { Readable } from 'svelte/store';
	import { getHubStores } from '$lib/stores/hubStores';
	export let editor: Readable<Editor>;

	const { hub } = getHubStores();

	onMount(async () => {
		if ($composerInitBlock === 'document') return;

		await tick();
		$editor.commands.insertContent(
			`<hubs-${$composerInitBlock}-component></hubs-${$composerInitBlock}-component>`
		);
	});
</script>

{#if $composerInitBlock === 'document'}
	<FileUploader
		openOnMount={true}
		on:fileUploaded={() => {
			$editor.commands.insertContent(`<hubs-document-component></hubs-document-component>`);
		}}
		accept=".jpg, .jpeg, .gif, .png, .webp, {!$hub.settings.feature.disableDocumentFileUploads &&
			'.pdf, .docx, .pptx, .mpg, .mov, .mpeg, .m4v, .mp4, .mp3'}"
		multiple={false}
	/>
{/if}
